export class EbookingRequestTugDTO {
    Id?: number;
    RequestId: string;
    ServiceId: number;
    TugType: number;
    Reason?: string;
    TugsNo: number;
    MeasurmentNote?: string;
    MarineNote?: string;
    AssignedBy: string;
    IsApproved?: boolean;
    ApprovedBy?: string;
    RejectionReason?: string;
    TugCategory?: number;
    IsDeleted?: boolean;
}

export class EbookingRequestTugDTOList {
    TugBoats: EbookingRequestTugDTO[];
}